import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import { AnchorLink, Icon, Tooltip } from 'platfi-ui-components';
import { Box, Chip } from '@capitalise/ui-design-system';

import styles from './QuickActionsButton.scss';

const QuickActionButton = (props) => {
  const { children, chip, icon, tooltip, ...rest } = props;

  const renderTooltipContent = (content) => (
    <div styleName="m-quick-action-button__tooltip-content">{content}</div>
  );

  return (
    <AnchorLink styleName="m-quick-action-button" {...rest}>
      <Box width="100%">
        {chip ? <Chip baseColor="purple">{chip}</Chip> : null}
        <Box alignItems="center" display="flex" justifyContent="space-between" width="100%">
          <div>
            <Icon
              className="a-svg-base-medium"
              icon={icon}
              styleName="m-quick-action-button__icon"
            />

            <span styleName="m-quick-action-button__label">{children}</span>
          </div>

          {tooltip ? (
            <Tooltip
              bottom
              component="div"
              mediumWidth
              right
              styleName="m-quick-action-button__tooltip"
              tooltipContentComponent={renderTooltipContent(tooltip)}
            >
              <Icon icon="round_info" className="a-svg-base" />
            </Tooltip>
          ) : null}
        </Box>
      </Box>
    </AnchorLink>
  );
};

QuickActionButton.propTypes = {
  children: PropTypes.node,
  chip: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  icon: PropTypes.string,
  tooltip: PropTypes.string,
};

export default CSSModules(QuickActionButton, styles);
